var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }